import type { BrandProduct } from '../types';

export const oakwood = {
  identity: {
    SHORT_NAME: 'Oakwood',
    FULL_NAME: 'Oakwood Mutual Insurance Company',
    LEGAL_NAME: 'Oakwood Mutual Insurance Company',
    EMAIL_SENDER: 'Oakwood Mutual',
    EMAIL_BCC: 'customerservice@oakwoodmutual.com',
    SUPPORT_NAME: 'Oakwood Mutual',
    DOMAIN: 'oakwoodmutual.com',
    SUPPORT_EMAIL: 'customerservice@oakwoodmutual.com',
    DISPLAY_NAME: 'Oakwood',
    MARKETING_NAME: 'Oakwood Mutual Insurance Company',
    POLICY_ISSUER: 'Oakwood Mutual Insurance Company',
    CLAIMS_HANDLER: 'Oakwood',
    REFERRAL_NAME: 'Oakwood Mutual',
    SOCIAL_HANDLE: 'Oakwood',
    AGENCY_SUPPORT_EMAIL: 'customerservice@oakwoodmutual.com',
    // brand-config-be keeps these two split into lines (PAYMENT_ADDRESS_LINES /
    // EXPEDITED_PAYMENT_ADDRESS_LINES); its payment-address.test.ts checks the two agree.
    PAYMENT_ADDRESS: 'Oakwood Mutual Insurance Company 1733 Morningstar Blvd Decatur, IN 46733-3810',
    EXPEDITED_PAYMENT_ADDRESS: 'Oakwood Mutual Insurance Company 1733 Morningstar Blvd Decatur, IN 46733-3810',
    CUSTOMER_SERVICE_PHONE: '800-247-8079',
    CUSTOMER_SERVICE_PHONE_LETTERS: '800-247-8079',
    // TODO: replace with real URL once provided by Oakwood
    PRIVACY_POLICY_URL: '#'
  },
  supportedStates: ['IN'],
  // Hold rateControlDate up to 5 days by default, 60 for underwriters (issue #32130).
  rateControlDate: { maxStaleDaysToBind: 5, underwriterMaxHoldDays: 60 },
  // Mutual: 15-day billing-hold cap, reason required, "hold cancellations as well" option available (#33568).
  billingHold: { maxDays: 15, teamLeaderMaxDays: 30, requireReason: true, holdCancellationsEnabled: true },
  // Rental needs Collision and Comprehensive, Roadside needs Collision, Lease/Loan Gap needs both (#37618).
  autoCoverageDependencies: {
    rentalRequiresCollision: true,
    roadsideRequiresCollision: true,
    loanRequiresPhysicalDamage: true,
    leaseLoanOffered: true
  }
} satisfies BrandProduct;
